import { compose, withProps, withState, withHandlers, lifecycle } from "recompose";
import geTopNineStoryImage from "../libs/getStoryImage";

const storyDefaultSettings = {
  hideTotalLikes: false,
  hidePostLikes: false,
  hideStats: true,
  hideSummaryCaption: false,
};

const storyFeatureFlags = {
  HIDE_TOTAL_LIKES: 1 << 2,
  HIDE_POST_LIKES: 1 << 3,
  HIDE_STATS: 1 << 4,
  HIDE_SUMMARY_CAPTION: 1 << 5,
};

const defaultKey =
  0 |
  (storyDefaultSettings.hideTotalLikes && storyFeatureFlags.HIDE_TOTAL_LIKES) |
  (storyDefaultSettings.hidePostLikes && storyFeatureFlags.HIDE_POST_LIKES) |
  (storyDefaultSettings.hideStats && storyFeatureFlags.HIDE_STATS) |
  (storyDefaultSettings.hideSummaryCaption && storyFeatureFlags.HIDE_SUMMARY_CAPTION);

export const withCustomizeTopNine = compose(
  withProps({
    defaultKey,
  }),
  withState("isCreatingNewStory", "setCreatingNewStory", false),
  withState("storySettings", "setCustomizeStorySettings", storyDefaultSettings),
  withState("stories", "setStories", { defaultKey: null }),
  withState("storyCustomizationKey", "setStoryCustomizationKey", defaultKey),
  withState("customizeModalOpen", "setCustomizeModalOpen", false),
  withHandlers({
    addStory: props => ({ storyUrl, storyUrlWithWatermark, customizationKey }) => {
      const newStories = {};
      newStories[customizationKey] = { storyUrl, storyUrlWithWatermark };
      props.setStories({ ...props.stories, ...newStories });
    },
  }),
  withHandlers({
    toggleCustomizeModal: props => () => props.setCustomizeModalOpen(!props.customizeModalOpen),
    setStorySettings: ({ setCreatingNewStory, setCustomizeModalOpen, ...props }) => params => {
      setCreatingNewStory(true);
      setCustomizeModalOpen(false);

      const { hideTotalLikes, hidePostLikes, hideStats, hideSummaryCaption } = params;
      const { stories, setStoryCustomizationKey, addStory } = props;
      const settingsKey =
        0 |
        (hideTotalLikes && storyFeatureFlags.HIDE_TOTAL_LIKES) |
        (hidePostLikes && storyFeatureFlags.HIDE_POST_LIKES) |
        (hideStats && storyFeatureFlags.HIDE_STATS) |
        (hideSummaryCaption && storyFeatureFlags.HIDE_SUMMARY_CAPTION);

      const currentSettingsStory = stories[settingsKey];
      if (currentSettingsStory) {
        setStoryCustomizationKey(settingsKey);
        setCreatingNewStory(false);
      } else {
        const { id: sourceId } = props.source;
        geTopNineStoryImage({ sourceId, hideTotalLikes, hidePostLikes, hideStats, hideSummaryCaption }).then(
          result => {
            const { storyUrl, storyWithWatermarkUrl } = result;
            addStory({
              storyUrl,
              storyUrlWithWatermark: storyWithWatermarkUrl,
              customizationKey: settingsKey,
            });
            setStoryCustomizationKey(settingsKey);
            setCreatingNewStory(false);
          }
        );
      }
    },
  })
);
